<template>
	<PreloaderComponent v-if="preloaderVisibility" />
	<FootprintTableSingle
		v-else
		:edit-mode="true"
		:edit-data="editData"
	/>
</template>

<script>
import SolFileAPIInstance from '@/api'

import FootprintTableSingle from './FootprintTableSingle'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export default {
	name: "FootprintTableSingleEdit",
	components: {
		PreloaderComponent,
		FootprintTableSingle
	},
	data() {
		return {
			editData: {},
			preloaderVisibility: true
		}
	},

	async mounted() {
		const { id } = this.$route.params;
		const response = await SolFileAPIInstance.getFootprintById(id)
		if (response.data) {
			this.editData = response.data
			this.preloaderVisibility = false
		}
	}
}
</script>